import { render, staticRenderFns } from "./DxToolPerformance.vue?vue&type=template&id=1124c3dc&"
import script from "./DxToolPerformance.vue?vue&type=script&lang=js&"
export * from "./DxToolPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports